export const NAV_GROUPS = [
  {
    title: '工作台',
    items: [
      { path: 'overview', label: '概览', icon: 'grid' },
      { path: 'playground', label: 'Playground', icon: 'play' },
    ],
  },
  {
    title: '控制台',
    items: [
      { path: 'tokens', label: '令牌管理', icon: 'key' },
      { path: 'logs', label: '调用日志', icon: 'file' },
      { path: 'models', label: '模型目录', icon: 'folder' },
      { path: 'recharge', label: '充值', icon: 'wallet' },
    ],
  },
  {
    title: '个人中心',
    items: [
      { path: 'profile', label: '个人中心', icon: 'user' },
      { path: 'wallet', label: '钱包台账', icon: 'ledger' },
      { path: 'referral', label: '邀请返利', icon: 'gift' },
    ],
  },
];

export const PAGE_TITLES = {
  overview: '数据看板',
  playground: 'Playground',
  tokens: '令牌管理',
  logs: '调用日志',
  models: '模型目录',
  recharge: '充值',
  profile: '个人中心',
  wallet: '钱包台账',
  referral: '邀请返利',
};
